export default class Image {
  constructor(){
    this._el = document.createElement("img");
    this._el.className = "vjs-thumbnails-img";
  }

  el() {
    return this._el
  }

  updateSrc(src){
    this.el().src = src;
  }
}
